import React from 'react';
import { Panel } from 'react-bootstrap';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import { ConfirmationButton } from '../../common/components/formControls';
import LabelWithTooltip from '../../common/components/LabelWithTooltip';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';

const List = ({ isReadonly, onDelete, t, ...rest }) => {
	const columns = [
		{
			header: t('EmailBounce_Email'),
			accessor: 'email',
			sortable: true
		},
		{
			header: t('EmailBounce_IsHard'),
			accessor: 'isHard',
			sortable: true,
			cell: isHard => t(isHard ? 'EmailBounce_Hard' : 'EmailBounce_Soft')
		},
		{
			header: t('EmailBounce_DSN'),
			accessor: 'dsn',
			sortable: true,
			cell: (dsn, bounce) => <LabelWithTooltip tooltip={bounce.status}><span style={{ color: '#337ab7', fontWeight: 'bold' }}>{dsn}</span></LabelWithTooltip>
		},
		{
			header: t('EmailBounce_Date'),
			accessor: 'date',
			sortable: true,
			cell: date => ui.formatDateTime(date)
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id) => <div>{!isReadonly && <ConfirmationButton onConfirmation={() => onDelete(id)}
				confirmationTitle={t('EmailBounce_DeleteConfirmationTitle')}
				confirmationMessage={t('EmailBounce_DeleteConfirmationMessage')}
				displayType={'inline'} label={t('Common_Delete')} />}</div>
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);